export const production = process.env.NODE_ENV === 'production';
